"use strict";

exports.__esModule = true;
exports.normalizePathSep = normalizePathSep;
exports.denormalizePagePath = denormalizePagePath;

function normalizePathSep(path) {
  return path.replace(/\\/g, '/');
}

function denormalizePagePath(page) {
  page = normalizePathSep(page);

  if (page.startsWith('/index/')) {
    page = page.slice(6);
  } else if (page === '/index') {
    page = '/';
  }

  return page;
}